import { defineComponent, reactive, watch } from "vue";
import styles from "./Sider.module.less";
import Menu from "../Menu/Menu";
import _ from "lodash";
import { useRouter } from "vue-router";
export default defineComponent({
  props: {
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: any) {
    const router = useRouter();
    const state = reactive({
      projectNameShow: true,
    })
    // 执行动画
    const runAnimation = _.debounce(() => {
      state.projectNameShow = false;
      setTimeout(() => {
        state.projectNameShow = true;
      }, 300)
    }, 300, { leading: true, trailing: false })
    // 柔和伸缩动画
    watch(() => props.isCollapsed, (nv) => {
      runAnimation();
    }, {
      immediate: true,
      deep: true,
    })
    // logo
    const Logo = () => (
      <div class={styles['logo-box']} style={{ opacity: state.projectNameShow ? 1 : 0 }} onClick={() => { router.push("/index") }}>
        <img src={require("@/assets/image/logosmall.png")} />
        <span v-show={!props.isCollapsed}>海伦钢琴售后管理</span>
      </div>
    )
    return () => (
      <div class={styles.sider} style={{ width: props.isCollapsed ? '50px' : '200px' }}>
        <Logo />
        <Menu isCollapsed={props.isCollapsed} />
      </div>
    )
  }
})